import React from 'react';
import { Accordion, AccordionItem } from '@dbk/ui-accordion';
import { AccordionPlusIcon, AccordionMinusIcon } from 'dwo-trading/dwo-component/src/web/components/icons';
import UploadHistoryListItemHeader from '../doc-upload-history-list-item-header';
import UploadHistoryListItemBody from '../doc-upload-history-list-item-body';
import { createContainer } from '@dbk-legacy/muster/react';


const uploadHistoryListItem = (props) => {
  const {
    i18n: { messages }, docupload: { statuses } } = props;
  return (
    <AccordionItem
      renderTitle={() => (
        <UploadHistoryListItemHeader
          data={props.data}
          statuses={statuses}
        />)}>
      <UploadHistoryListItemBody
        messages={messages}
        data={props.data}
        statuses={statuses}
        onViewDocClick={props.onViewDocClick}
        onDownloadClick={props.onDownloadClick} />
    </AccordionItem>
  )
}

const UploadHistoryList = (props) => {
  return (<Accordion
    renderIconForOpen={() => <AccordionMinusIcon />}
    renderIconForClose={() => <AccordionPlusIcon />}
    fullWidth
    >
    {uploadHistoryListItem(props)}
  </Accordion>
  )
}

export default createContainer({
  $queries: {
    i18n: {
      messages: true,
    },
    docupload: {
      statuses: true
    }
  }
})(UploadHistoryList);

